import { Check } from "lucide-react";
import { PageLayout, PageBody, BookNowButton } from "@/components/site/PageLayout";

const WASH_ITEMS = [
  "Lower sections sprayed with pre-wash to remove road film",
  "Pre-wash applied to break up bug guts, bird poop, road film, mag chloride, etc.",
  "Emblems cleaned",
  "A thorough wash of the exterior",
  "Glass cleaned",
];

const WHEEL_ITEMS = [
  "Wheels cleaned",
  "Wheel wells cleaned",
  "Tires thoroughly cleaned",
  "Tires dressed",
];

const PRICING = [
  ["Travel Trailers", "from $8 per foot"],
  ["5th wheels", "from $10 per foot"],
  ["Toy Haulers", "from $10 per foot"],
  ["Class C Motorhomes", "from $10 per foot"],
  ["Sprinter/Transit conversions", "from $200"],
  ["Class A/Super C", "from $12 per foot"],
  ["Roof cleaning", "from $3 per foot"],
];

export default function RvPage() {
  return (
    <PageLayout
      eyebrow="Camper & RVs"
      title="RV detailing"
      titleAccent="packages"
    >
      <PageBody>
        <article data-testid="rv-premium-wash" className="bg-[#121216] border border-[#232329] p-7 md:p-10">
          <h2 className="font-display uppercase text-2xl md:text-3xl tracking-wide text-white">Premium Wash</h2>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="font-display uppercase text-sm tracking-[0.15em] text-[#FF4311]">Wash:</h3>
              <ul className="mt-3 space-y-2.5">
                {WASH_ITEMS.map((i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm text-slate-300">
                    <Check className="w-4 h-4 mt-0.5 text-[#EA0A0B] shrink-0" />{i}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="font-display uppercase text-sm tracking-[0.15em] text-[#FF4311]">Wheels:</h3>
              <ul className="mt-3 space-y-2.5">
                {WHEEL_ITEMS.map((i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm text-slate-300">
                    <Check className="w-4 h-4 mt-0.5 text-[#EA0A0B] shrink-0" />{i}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <ul className="mt-6 space-y-2">
            {PRICING.map(([k, v]) => (
              <li key={k} className="flex items-center justify-between gap-4 text-sm text-slate-300 border-b border-white/5 pb-2">
                <span>{k}</span><span className="text-[#FF4311] font-semibold">{v}</span>
              </li>
            ))}
          </ul>
        </article>

        <article data-testid="rv-premium-wash-wax" className="mt-8 bg-[#121216] border border-[#232329] p-7 md:p-10">
          <h2 className="font-display uppercase text-2xl md:text-3xl tracking-wide text-white">Premium Wash & Wax</h2>
          <p className="mt-4 text-sm text-slate-300 leading-relaxed">
            Same thorough wash — lower sections sprayed with pre-wash, emblems cleaned, glass
            cleaned, wheels and wheel wells cleaned, tires cleaned and dressed — plus wax applied.
          </p>
          <p className="mt-4 font-display text-xl text-[#FF4311]">Travel Trailers from $12.50 per foot</p>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-5">
            <img
              src="/gallery/owner-3.jpg"
              alt="RV detail in progress — foam wash on a motorhome"
              className="w-full aspect-[4/3] object-cover"
            />
            <img
              src="/gallery/owner-2.jpg"
              alt="Brad hand-washing an RV motorhome — Brad's Mobile Detailing at work"
              className="w-full aspect-[4/3] object-cover"
            />
          </div>
        </article>

        <div className="mt-10">
          <BookNowButton to="/schedule" label="Book With Us" testid="rv-book-button" />
        </div>
      </PageBody>
    </PageLayout>
  );
}
